import jwtDecode from 'jwt-decode';

// Função para verificar se o token está expirado
export default function isTokenExpired(token) {
    try {
        let decodedToken    = jwtDecode(token);
        let expirationDate  = new Date(decodedToken.exp * 1000); // Multiplica por 1000 para converter segundos em milissegundos
        let currentDate     = new Date();
        return currentDate >= expirationDate;
    } catch (error) {
        // Caso ocorra algum erro na decodificação do token (token inválido, por exemplo)
        return false;
    }
}